// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gm1jC","data":"styles_data__fzF4y","spin":"styles_spin__pulWm"};